/*** IMPORTS FROM imports-loader ***/
(function() {

require([
    'jquery',
    'cookie-utils',
    'commission-junction',
    'pip-domain',
    'auth.service',
    'verification.service',
    'pip-recommendations',
    'pip-expose-tnt-objects',
    'pip-analytics'
],
function (
    $,
    cookieUtils,
    commissionJunction,
    pipDomain,
    myAccountService,
    myVerificationService,
    pipRecommendations,
    pipExposeTntObjects,
    pipAnalytics

){

    if (typeof DIGITAL_EMITTER !== 'undefined') {
        DIGITAL_EMITTER.trigger('jquery-ready');
    }

    if(window.thdOnlineCommon){
        window.thdOnlineCommon.appAlias = "S6";
    }

    $(function() {
        pipExposeTntObjects.init();
        cookieUtils.initializeCookieManager(pipDomain.getCookieDomain(), 'web');
        commissionJunction.updateCJInfo();
        myAccountService.init();
        myVerificationService.init();
        pipRecommendations.outOfStockRecsThdSchemas();
        pipAnalytics.init();

        var afterBundleEvent = document.createEvent('CustomEvent');
        afterBundleEvent.initCustomEvent('afterBundle', false, false, {});
        document.dispatchEvent(afterBundleEvent);
    });
});

}.call(window));